import { Outlet, useLocation } from 'react-router'

import { SettingsRoutes } from 'app/application/types'

import styles from './Settings.module.scss'
import { SettingsSidebar } from './components'

const Settings = () => {
  const location = useLocation()
  const activeRoute = (location.pathname.split('/').at(-1) ??
    SettingsRoutes.General) as SettingsRoutes

  return (
    <div className={styles.settings}>
      <SettingsSidebar activeRoute={activeRoute} />
      <main className={styles.main}>
        <div className={styles.mainContent}>
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export default Settings
